var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192038",
    d: "M32.917 24.583a3.334 3.334 0 013.333 3.334v7.5a3.333 3.333 0 01-3.333 3.333H6.667a3.334 3.334 0 01-3.334-3.333v-7.5a3.334 3.334 0 013.334-3.334h26.25zm0 .834H6.667a2.5 2.5 0 00-2.496 2.353l-.004.147v7.5c0 1.331 1.04 2.42 2.353 2.495l.147.005h26.25a2.5 2.5 0 002.495-2.353l.005-.147v-7.5a2.5 2.5 0 00-2.353-2.496l-.147-.004zm2.916-5.834c.23 0 .417.224.417.5s-.187.5-.417.5H3.75c-.23 0-.417-.224-.417-.5s.187-.5.417-.5h32.083zM32.917 1.25a3.333 3.333 0 013.333 3.333v7.5a3.334 3.334 0 01-3.333 3.334H6.667a3.334 3.334 0 01-3.334-3.334v-7.5A3.334 3.334 0 016.667 1.25h26.25zm0 .833H6.667a2.5 2.5 0 00-2.496 2.353l-.004.147v7.5a2.5 2.5 0 002.353 2.496l.147.004h26.25c1.331 0 2.42-1.04 2.495-2.353l.005-.147v-7.5a2.5 2.5 0 00-2.353-2.495l-.147-.005z"
  }))));
}

export default SvgDivider;